var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAurora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_1275_22499)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0005 9.792C24.6197 9.79004 25.2271 9.96144 25.7539 10.2868C26.2807 10.6122 26.706 11.0785 26.9815 11.633L36.3565 30.383C36.6109 30.8912 36.7311 31.456 36.7057 32.0238C36.6804 32.5915 36.5102 33.1433 36.2115 33.6268C35.9128 34.1103 35.4954 34.5094 34.9991 34.7861C34.5027 35.0629 33.9438 35.2081 33.3755 35.208H14.6255C14.0573 35.2079 13.4985 35.0626 13.0023 34.7858C12.506 34.509 12.0888 34.1099 11.7902 33.6264C11.4916 33.1429 11.3216 32.5912 11.2963 32.0235C11.2709 31.4558 11.3912 30.8911 11.6455 30.383L21.0195 11.633C21.295 11.0785 21.7203 10.6122 22.2471 10.2868C22.7739 9.96144 23.3813 9.79004 24.0005 9.792M24.0005 7.5C22.956 7.4999 21.9322 7.79059 21.0436 8.33952C20.1551 8.88846 19.4369 9.67394 18.9695 10.608L9.59456 29.358C9.16544 30.2156 8.96271 31.1687 9.00564 32.1268C9.04856 33.0848 9.33572 34.016 9.83982 34.8318C10.3439 35.6476 11.0482 36.321 11.8858 36.788C12.7234 37.255 13.6665 37.5001 14.6255 37.5H33.3755C34.3344 37.4999 35.2773 37.2547 36.1148 36.7876C36.9523 36.3206 37.6565 35.6472 38.1604 34.8314C38.6644 34.0156 38.9515 33.0845 38.9944 32.1265C39.0373 31.1686 38.8345 30.2156 38.4054 29.358L29.0315 10.608C28.5641 9.67394 27.8459 8.88846 26.9574 8.33952C26.0688 7.79059 25.0449 7.4999 24.0005 7.5V7.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_22499",
    x1: 48,
    y1: -0.00000286102,
    x2: 0.00000286102,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95E141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C9A2C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.a3530765e03098c40765492bc00f53f6.svg";
export { ForwardRef as ReactComponent };